/* eslint-disable no-extend-native */
import { GLOBAL_CONSTANTS } from '../global/constants';
import getOr from "lodash/fp/getOr";
import { LocalStorage } from '../models/LocalStorage';

export function isMobile() {
  return LocalStorage.isMiniApp() || (window.outerWidth > 0 && window.outerWidth <= 768);
}

export function isMobileByWidth() {
  return window.outerWidth > 0 && window.outerWidth <= 768;
}

export function nFormatter(num, digits = undefined, unit = "") {
  const si = [
    { value: 1, symbol: "" },
    { value: 1E3, symbol: "K" },
    { value: 1E6, symbol: "M" },
    { value: 1E9, symbol: "B" },
    { value: 1E12, symbol: "T" },
    { value: 1E15, symbol: "Qa" },
    { value: 1E18, symbol: "Qi" }
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  let i;
  for (i = si.length - 1; i > 0; i--) {
    if (num * 1 >= si[i].value) {
      break;
    }
  }
  return unit + (num / si[i].value).toFixed(digits !== undefined ? digits : i * 3).replace(rx, "$1") + (si[i].symbol ? " " : "") + si[i].symbol;
}

export function isInViewport(element) {
  var top_of_element = element.offset().top;
  var bottom_of_element = element.offset().top + element.outerHeight();
  var bottom_of_screen = window.$(window).scrollTop() + window.$(window).innerHeight();
  var top_of_screen = window.$(window).scrollTop();

  if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
    return true;
  } else {
    return false;
  }
}

export function scrollTo(selector, distance = 40, duration = 1000) {
  window.$('html, body').animate({
    scrollTop: window.$(selector).offset().top - distance
  }, duration);
}

export function scrollToTop(duration = 0) {
  $('html, body').animate({
    scrollTop: 0
  }, duration);
}

export function getTierFromCode(code) {
  let result = GLOBAL_CONSTANTS.PLANS.free;
  Object.keys(GLOBAL_CONSTANTS.PLANS).forEach(key => {
    if (code * 1 === GLOBAL_CONSTANTS.PLANS[key].id) {
      result = GLOBAL_CONSTANTS.PLANS[key];
    }
  });
  return result;
}

export function getMessage(error, defaultMess = GLOBAL_CONSTANTS.DEFAULT_ERROR) {
  return getOr(defaultMess, "message")(error)
}

export function swapArrayLocs(arr, index1, index2) {
  let temp = arr[index1];

  arr[index1] = arr[index2];
  arr[index2] = temp;
}

export function isEmpty(element) {
  if (Array.isArray(element)) return isEmptyArray(element);
  if (element && typeof element === "object") return isEmptyObject(element);
  return isEmptyCharacter(element);
}

export function isEmptyArray(arr) {
  if (!arr || !arr.length) return true;

  for (let index = 0; index < arr.length; index++) {
    const element = arr[index];

    if (!isEmpty(element)) return false;
  }
  return true;
}
export function isEmptyObject(obj) {
  let keys = Object.keys(obj);
  if (keys.length === 0) return true;
  for (let index = 0; index < keys.length; index++) {
    const key = keys[index];
    const element = obj[key];

    if (!isEmpty(element)) return false;
  }
  return true;
}

export function isEmptyCharacter(char) {
  return char === undefined || char === null || char === "" || char === "null";
}

export function genQueryFromArray(arr) {
  if (Array.isArray(arr)) {
    let result = "";
    for (let i = 0; i < arr.length; i++) {
      result += arr[i] + ",";
    }
    return result.replace(/,\s*$/, "");
  } else {
    return arr;
  }
}

export function getSettingsPicker() {
  let shipping = (LocalStorage.getShipping() || "");
  let currency = (LocalStorage.getCurrency() || "");
  return (shipping + currency).toLowerCase();
}

export function isCountryVN(value) {
  if (!value) return false;
  if (typeof value !== "string") return false;
  const VNCode = "VN";
  return value.toUpperCase() === VNCode ? VNCode : false;
}


/**
 * @param {Array} list 
 * @returns {[{label: string, value: string}]}
 */
export function convertOptionList(list, value = "value", label = "label") {
  let result = [];
  if (Array.isArray(list) && list.length > 0) {
    list.forEach(element => {
      let item = {
        ...element,
        value: element[value],
        label: element[label]
      }
      result.push(item);
    });
  }
  return result;
}

export const messageSelector = (error) => getOr(GLOBAL_CONSTANTS.DEFAULT_ERROR, "message")(error);

export function lockScroll(value = true) {
  value ? $("body").addClass("lock-scroll") : $("body").removeClass("lock-scroll");
}


export function setCollapseElement(id, selector, content, isShow = true) {
  $(selector).attr("data-toggle", "collapse");
  $(selector).attr("data-target", `#${id}`);
  $(selector).attr("aria-expanded", isShow);
  !isShow && $(selector).addClass("collapsed");
  $(content).attr("id", id);
  $(content).addClass(isShow ? "collapse show" : "collapse");
}

export function setStyleElement(el, style) {
  if (!el || !el.length || !style) return;
  el.attr("style", style);
}